<template>
    <div class="container" id="goods-edit">
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
        <!-- 面包屑导航 -->
        <!-- 查询 -->
        <div class="content c-top">
            <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
            <el-form :model="infoForm" :rules="infoRules" ref="infoForm" label-width="100px" class="info-form"
                style="margin-top: 10px;">
                <el-form-item label="礼包名称" prop="name">
                    <el-input style="width: 442px" v-model="infoForm.name" placeholder="请输入礼包名称" maxlength="30"
                        :disabled="$route.query.type == 'look'" show-word-limit clearable></el-input>
                </el-form-item>
                <el-form-item label="商品">
                    <div v-for="(item, index) in goodsList" :key="index" style="display: flex;margin-bottom:10px">
                        <div>{{ item.goodsSkuName }}</div>
                        <div style="margin-left:20px"><el-input-number v-model="item.num" :min="1"
                                :disabled="$route.query.type == 'look'" label="描述文字"></el-input-number></div>
                        <div v-if="$route.query.type != 'look'"><i class="el-icon-delete"
                                style="font-size: 20px;color:red;margin-left:20px;cursor: pointer;"
                                @click="deleteGoods(index)"></i></div>
                    </div>
                    <div style="color:#2d46ee;cursor: pointer;width:80px" @click="addShopGoods"
                        v-if="$route.query.type != 'look'">+新增</div>
                </el-form-item>
                <el-form-item label="礼包包含类目">
                    <el-select style="width: 442px" v-model="infoForm.categoryId" placeholder="请选择礼包类目" filterable disabled
                        multiple clearable>
                        <el-option v-for="(item, index) in categoryIds" :key="index" :label="item.categoryName"
                            :value="item.categoryNo"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="礼包商品编号" class="code" v-if="$route.query.type != 'add'">
                    <el-input v-model="infoForm.code" style="width: 442px" placeholder="请输入商品编号" disabled></el-input>
                </el-form-item>
                <div style="
              width: 674px;
              height: 0px;
              border: 1px dashed #ebebfa;
              opacity: 1;
              margin-bottom: 6px;
            "></div>
            </el-form>
        </div>
        <div class="content image-text-form">
            <h3>筛选标签设置</h3>
            <el-form label-width="100px">
                <el-form-item :label="item.label" v-for="(item, index) in tagIds1" :key="index">
                    <el-select style="width: 442px" :placeholder="'请选择' + item.label + '(可多选)'" multiple
                        :disabled="$route.query.type == 'look'" v-model="Tag[index]" @change="selectT($event, index)">
                        <el-option v-for="(item, index) in item.children" :key="item.value" :value="item.value"
                            :label="item.label">

                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <h3>展示标签设置</h3>
            <el-form label-width="100px">
                <el-form-item :label="item.label" v-for="(item, index) in tagIdsShow1" :key="index">
                    <el-select style="width: 442px" :placeholder="'请选择' + item.label + '(可多选)'" multiple
                        :disabled="$route.query.type == 'look'" v-model="Tag1[index]" @change="selectTs($event, index)">
                        <el-option v-for="(item, index) in item.children" :key="item.value" :value="item.value"
                            :label="item.label">

                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <h3>营销标签设置</h3>
            <el-form label-width="100px" class="info-form">
                <el-form-item label="选择标签">
                    <el-select style="width: 442px" v-model="tagMarketingsT" placeholder="请选择标签（可多选）" ref="refTag"
                        @change="changeD($event)" :disabled="$route.query.type == 'look'"
                        @visible-change="changeTag($event)" multiple v-if="!isSelect">
                        <el-option v-for="item in tagMarketings" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                    <div style="width:442px;min-height: 38px;border-radius: 4px;border: 1px solid #DCDFE6;display: flex;justify-content: space-between;"
                        v-else @click="openSelect">
                        <div v-if="tagMarketing.length == 0" style="margin-left:15px;color: #c0c9db;">请选择标签（可多选）</div>
                        <draggable v-else @start="start" @end="end" v-model="tagMarketing"
                            style="display: flex;padding:8px 8px;flex-wrap: wrap;">
                            <div v-for="(item, index) in tagMarketing" :key="index" effect="dark" closable
                                style="margin-right:10px;margin-bottom: 4px;" class="dItem">
                                <div style="display: flex;">
                                    <div style="margin-left: 6px;"> {{ item.name }}</div>
                                    <div
                                        style="background-color: #c0c4cc;width:12.8px;height:12.6px;border-radius: 50%;color:#909399;margin-top: 5px;margin-left: 6px;margin-right: 6px;">
                                        <div style="margin-top: -5px;"><i style="font-size: 10px;"
                                                class="el-icon-close"></i></div>

                                    </div>
                                </div>

                            </div>
                        </draggable>
                        <div style="margin-right: 12px;display: flex;flex-direction: column;justify-content: center;"><i
                                style="color: #C0C4CC;font-size: 14px;" class="el-icon-arrow-down"></i>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div class="content image-text-form">
            <h3>运费设置</h3>
            <el-form label-width="100px">
                <el-form-item label="运费设置">
                    <el-select style="width: 442px" v-model="infoForm.shippingTemplateId" @change="getTransportModel"
                        :disabled="$route.query.type == 'look'">
                        <el-option v-for="item in models" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <!-- <el-radio-group v-model="radio">
            <el-radio :label="3">按件数</el-radio>
            <el-radio :label="6">按重量</el-radio>
          </el-radio-group> -->
                    <number v-if="detail.calculType == 1" :isEdit="false" :tableData="tableData" :freight="detail.freight"
                        :baseNumber="detail.baseNumber" :addNum="detail.addNum" :addPrice="detail.addPrice"></number>
                    <weight v-if="detail.calculType == 2" :isEdit="false" :tableData="tableData" :freight="detail.freight"
                        :baseNumber="detail.baseNumber" :addNum="detail.addNum" :addPrice="detail.addPrice"></weight>
                    <free-delivery v-if="tableDataF.length != 0" :tableData="tableDataF" style="margin-top: 10px"
                        :isEdit="false"></free-delivery>
                </el-form-item>
            </el-form>
        </div>
        <div class="content image-text-form">
            <h3>图文信息</h3>
            <el-form label-width="100px">
                <el-form-item label="商品图片(0/10)" v-if="$route.query.type != 'look'">
                    <label slot="label"><span style="color: red">*</span>商品图片({{
                        this.fileList.length
                    }}/10)</label>
                    <div style="display: flex" v-if="isUpdate">
                        <div class="itemI" style="margin-left: 8px" v-for="(item, index) in fileList" :key="item + index">
                            <el-image style="width: 108px; height: 108px; border-radius: 6px" :src="item.url"></el-image>
                            <span v-if="index == 0" style="
                    color: #2d46ee;
                    position: absolute;
                    top: 100px;
                    left: 10px;
                  ">（商品主图）</span>
                        </div>
                    </div>

                    <upload-picture v-else :limit="10" :list="fileList" @changeImage="changeImage" />
                    <!--          <upload-picture></upload-picture>-->
                </el-form-item>
                <el-form-item label="商品图片(0/10)" v-else>
                    <label slot="label"><span style="color: red">*</span>商品图片({{
                        this.fileList.length
                    }}/10)</label>
                    <div style="display: flex">
                        <div class="itemI" style="margin-left: 8px" v-for="(item, index) in fileList" :key="item + index">
                            <el-image style="width: 108px; height: 108px; border-radius: 6px" :src="item.url"></el-image>
                            <span v-if="index == 0" style="
                  color: #2d46ee;
                  position: absolute;
                  top: 100px;
                  left: 10px;
                ">（商品主图）</span>
                        </div>
                    </div>

                    <!-- <upload-picture
            :limit="10"
            :list="fileList"
            @changeImage="changeImage"
          /> -->
                    <!--          <upload-picture></upload-picture>-->
                </el-form-item>
                <el-form-item label="">
                    <div style="
                font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 16px;
                color: #909099;
              ">
                        图片尺寸：建议上传750px*750px，每张上传大小不得超过2M,支持jpg、jpeg、png格式
                    </div>
                </el-form-item>
                <el-form-item label="商品详情">
                    <label slot="label"><span style="color: red">*</span>商品详情</label>
                    <!--          <editor :init="editorInit" v-model="infoForm.detail" api-key="70xmc76i21jyu8ob8fmf4dtcjfpz0atkne1ttkxppmzsu230"/>-->
                    <!-- <tinymce v-model="infoForm.details"></tinymce> -->
                    <quill-editor v-model="infoForm.details" ref="myQuillEditor" :options="editorOption" class="editor"
                        :disabled="$route.query.type == 'look'"></quill-editor>
                    <div class="bottom" style="display: none">
                        <el-upload class="centerImg" :action="' '" list-type="picture-card" :auto-upload="false"
                            :on-change="handleAvatarChangeIcon" ref="uploadicon">
                        </el-upload>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div class="content" id="sku-content">
            <div style="display: flex">
                <h3>价格库存</h3>
            </div>

            <div class="sku-box" style="width:calc(100% - 16px)">
                <el-table :data="sku1" :header-cell-style="{ background: '#fafafa', color: '#333333' }" border>
                    <el-table-column prop="updatedTime" label="规格图片">
                        <template slot="header">
                            <div><span style="color:red">*</span>规格图片</div>
                        </template>
                        <template slot-scope="props">
                            <mall-picture :imageUrl="props.row.images"
                                @getUrl="getImage1($event, props.$index)"></mall-picture>
                        </template>
                    </el-table-column>
                    <el-table-column prop="marketPrice" label="市场价">
                        <template slot="header">
                            <div><span style="color:red">*</span>市场价</div>
                        </template>
                        <template slot-scope="props">
                            <div>
                                <el-input v-model="props.row.marketPrice" placeholder="请输入市场价"
                                    :disabled="$route.query.type == 'look'"></el-input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="零售价">
                        <template slot="header">
                            <div><span style="color:red">*</span>零售价</div>
                        </template>
                        <template slot-scope="props">
                            <div>
                                <el-input v-model="props.row.price" placeholder="请输入零售价" @change="changePrice"
                                    :disabled="$route.query.type == 'look'"></el-input>
                            </div>
                        </template>
                    </el-table-column>
                    <!-- 内购价 -->
                    <el-table-column prop="purchasePrice" label="内购价" @change="changePurchasePrice">
                        <template slot="header">
                            <div><span style="color:red">*</span>内购价</div>
                        </template>
                        <template slot-scope="props">
                            <div> 
                                <el-input v-model="props.row.purchasePrice"  placeholder="请输入内购价"
                                    disabled></el-input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="points" label="赠送积分">
                        <template slot="header">
                            <div><span style="color:red">*</span>赠送积分</div>
                        </template>
                        <template slot-scope="props">
                            <div>
                                <el-input v-model="props.row.points" placeholder="请输入赠送积分"
                                    :disabled="$route.query.type == 'look'"></el-input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stock" label="库存">
                        <template slot="header">
                            <div><span style="color:red">*</span>库存</div>
                        </template>
                        <template slot-scope="props">
                            <div>
                                <el-input v-model="props.row.stock" placeholder="请输入库存"
                                    :disabled="$route.query.type == 'look'"></el-input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="fakeSaleNum" label="虚拟销量">
                        <template slot-scope="props">
                            <div>
                                <el-input v-model="props.row.fakeSaleNum" placeholder="请输入虚拟销量"
                                    :disabled="$route.query.type == 'look'"></el-input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="saleNum" label="真实销量">
                        <template slot-scope="props">
                            <div>
                                <el-input v-model="props.row.saleNum" placeholder="请输入真实销量" disabled></el-input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态">
                        <template slot="header">
                            <div><span style="color:red">*</span>状态</div>
                        </template>
                        <template slot-scope="props">
                            <div>
                                <el-switch active-color="#2D46EE" v-model="props.row.status" active-value="1"
                                    :disabled="$route.query.type == 'look'" inactive-value="0"></el-switch>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="margin-top:10px">
                <el-form>
                    <el-form-item label="佣金" label-width="100px">
                        <label slot="label"><span style="color: red">*</span>佣金</label>
                        <div v-for="(item, index) in commissions" :key="index" style="display:flex;margin-bottom:10px">
                            <div>推荐第{{ index + 1 }}个次</div>
                            <div style="margin-left:10px;margin-right:10px"><el-input v-model="item.rate"
                                    @change="changeRate($event, index)" :disabled="$route.query.type == 'look'"></el-input>
                            </div>
                            <div>%，将获得{{ item.price }}元收益</div>
                        </div>
                        <div style="display:flex;justify-content:start">
                            <el-checkbox-group v-model="checkList" :max="1">
                                <el-checkbox label="1">个人购买第1次后自己购买的佣金归自己</el-checkbox>
                            </el-checkbox-group>


                            <!-- <el-radio style="margin-top:12px;margin-right:0px!important" v-model="selfCommissionFlag"
                                label="1" @click="changeR(selfCommissionFlag)"> 个人购买第1次后自己购买的佣金归自己

                            </el-radio> -->
                            <!-- <div>个人购买第1次后自己购买的佣金归自己</div> -->
                        </div>
                    </el-form-item>
                    <el-form-item label="有效期" label-width="100px">
                        <label slot="label"><span style="color: red">*</span>有效期</label>
                        <el-date-picker size="small" style="width: 442px" v-model="startTime" type="daterange"
                            :disabled="$route.query.type == 'look'" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div class="content bottom-but">
            <el-button type="info" @click="back">返回</el-button>
            <el-button type="primary" @click="verificationData" v-if="$route.query.type != 'look'">确定</el-button>
        </div>
        <el-dialog title="选择商品" :visible.sync="isSelectGoods" width="50%" :append-to-body="true">
            <el-transfer filterable :filter-method="filterMethod" v-model="chooseGoods" :data="goodsSkuDataList"
                ref="myTransfer" class="transfer-gift-form" :props="{ key: 'goodsSkuId', label: 'goodsSkuName' }"
                :titles="['商品列表', '已选列表']">
                <div slot-scope="{ option }">
                    <span class="transfer-label" :title="option.goodsSkuName">{{ option.goodsSkuName }}</span>
                </div>
            </el-transfer>
            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="isSelectGoods = false">取消</div>
                <div class="info-s" @click="selectData">确定</div>
            </div>
        </el-dialog>
    </div>
</template>
  
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
import imageResize from 'quill-image-resize-module' // 引用
import { ImageDrop } from 'quill-image-drop-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', imageResize) // 注册

// import Tinymce from '@/components/Tinymce/index'
import uploadPicture from '@/components/upload/dragpicture.vue'
// import sku from "./components/sku/index"
import formFiled from '@/components/form/index'
import formFiled1 from '@/components/form/indexL'
import SkuForm from 'vue-sku-form'
import mixinsGoodsEdit from '../mixins/mixinsGoodsEdit.js'
import mixinsGoodsEditQuill from '../mixins/mixinsGoodsEditQuill.js'

import mixinsGiftlist from '../mixins/mixinsGiftlist.js'

import ModifyState from '../components/ModifyState.vue'

import common from '../mixins/common'
import number from '../components/number.vue'
import weight from '../components/weight.vue'
import FreeDelivery from '../components/freeDelivery.vue'
import mallPicture from '@/components/upload/mallPicture.vue'
import categoryDialog from '../components/categoryDialog.vue'
import draggable from 'vuedraggable'
const checkNumber = (data, index, callback) => {
    const val = data[index].stock
    // console.log(typeof val === 'number', !isNaN(val))
    console.log(typeof val === 'number' && !isNaN(val))
    if (!isNaN(val)) {
        callback()
    }
    callback(new Error('填写有误'))
}
export default {
    components: {
        breadcrumbTop,
        breadcrumbSearch,
        uploadPicture,
        formFiled,
        formFiled1,
        SkuForm,
        quillEditor,
        ModifyState,
        number,
        weight,
        FreeDelivery,
        mallPicture,
        categoryDialog,
        draggable
    },
    data() {
        return {
            checkList: [],
            sku1: [
                {
                    images: '',
                    marketPrice: '',
                    price: '',
                    points: '',
                    stock: '',
                    fakeSaleNum: '',
                    saleNum: '',
                    status: ''
                }
            ],
            startTime: [],
            commissions: [{
                rate: '0',
                price: '0.00'
            }, {
                rate: '0',
                price: '0.00'
            }, {
                rate: '0',
                price: '0.00'
            }],
            chooseGoods: [],
            goodsSkuDataList: [

            ],
            isSelectGoods: false,
            isSelect: false,
            sTags: [],
            tags: [

            ],
            goodsName: '',
            goodsList: [


            ],
            dialogGoods: false,
            cIds: [],
            dialogCategory: false,
            isChangeC: false,
            isChange: false,
            isCostPrice: false,
            currentIndex: 0,
            currentData: {},
            isStatus: false,
            isInfo: false,
            time: 0,
            isUp: false,
            dataList: {
                list: [
                    { title: '商品管理', path: '/shopManagement/giftManagement', type: '0' },
                    { title: '礼包管理', path: '/shopManagement/giftManagement', type: '1' },

                ]
            },
            searchList: {
                list: [
                    { title: '新增礼包', path: '', type: '0' },
                    { title: '基础信息', path: '', type: '1' }
                ]
            },
            radio: 3,
            fileList: [],
            currentPageStatus: 'add', // 当前页面状态 add 添加 ， edit 编辑
            breadcrumbTitle: '新增商品',
            maxSkuNo: 1, // 通过接口获取最大 skuNo
            formFiledDataState: true, // 类目属性 状态
            skuFormConfig: {
                sourceAttribute: [], // SKU可选属性
                attribute: [], // SKU已选属性，支持 .sync 修饰符
                structure: [ // 表单结构
                    {
                        name: 'marketPrice', type: 'slot', label: '市场价(元)', batch: false, required: true,
                        validate: (data, index, callback) => {
                            // console.log(data)
                            const val = data[index].marketPrice
                            if (!isNaN(val) && val > -1) {
                                data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
                                this.skuItemHandle(data[index])
                                callback()
                            }
                            callback(new Error('填写有误'))
                        }
                    },
                    {
                        name: 'retailPrice', type: 'slot', label: '零售价(元)', batch: false, required: true,
                        validate: (data, index, callback) => {
                            const val = data[index].retailPrice
                            if (!isNaN(val) && val > -1) {
                                data[index].retailPrice = Number(data[index].retailPrice).toFixed(2)
                                data[index].platformCommission = Number((data[index].settlementPrice * this.serverRate) / 100)
                                data[index].platformProfit = Number(data[index].retailPrice) - Number(data[index].settlementPrice)
                                data[index].platformUserCommission = Math.floor(((data[index].retailPrice * data[index].platformCommissionRate) / 100) * 100) / 100 + Math.floor(((data[index].retailPrice * data[index].firstNormalCommProp) / 100) * 100) / 100
                                // data[index].platformUserCommission = Number((data[index].retailPrice * data[index].platformCommissionRate) / 100)
                                data[index].platformProfitPrice = Number(data[index].platformProfit) - Number(data[index].platformUserCommission)
                                console.log(55555)


                                callback()
                            }
                            callback(new Error('填写有误'))
                        }
                    },
                    {
                        name: 'retailPrice', type: 'slot', label: '赠送积分', batch: false, required: true,
                        validate: (data, index, callback) => {
                            const val = data[index].retailPrice
                            if (!isNaN(val) && val > -1) {
                                data[index].retailPrice = Number(data[index].retailPrice).toFixed(2)
                                data[index].platformCommission = Number((data[index].settlementPrice * this.serverRate) / 100)
                                data[index].platformProfit = Number(data[index].retailPrice) - Number(data[index].settlementPrice)
                                data[index].platformUserCommission = Math.floor(((data[index].retailPrice * data[index].platformCommissionRate) / 100) * 100) / 100 + Math.floor(((data[index].retailPrice * data[index].firstNormalCommProp) / 100) * 100) / 100
                                // data[index].platformUserCommission = Number((data[index].retailPrice * data[index].platformCommissionRate) / 100)
                                data[index].platformProfitPrice = Number(data[index].platformProfit) - Number(data[index].platformUserCommission)
                                console.log(55555)


                                callback()
                            }
                            callback(new Error('填写有误'))
                        }
                    },




                    {
                        name: 'retailPrice', type: 'slot', label: '库存', batch: false, required: true,
                        batch: false,
                        validate: (data, index, callback) => {
                            const val = data[index].stock
                            if (!isNaN(val) && val > -1) {
                                data[index].stock = Number(data[index].stock).toFixed(0)
                                callback()
                            }
                            callback(new Error('填写有误'))
                        }
                    },

                    {
                        name: 'retailPrice', type: 'slot', label: '虚拟销量', batch: false, required: false,
                        validate: (data, index, callback) => {
                            const val = data[index].initSellNum
                            if (!isNaN(val) && val > -1) {
                                data[index].initSellNum = Number(data[index].initSellNum).toFixed(0)
                                callback()
                            }
                            callback(new Error('填写有误'))
                        }
                    },
                    {
                        name: 'retailPrice', type: 'slot', label: '真实销量', batch: false, required: false,
                        validate: (data, index, callback) => {
                            const val = data[index].initSellNum
                            if (!isNaN(val) && val > -1) {
                                data[index].initSellNum = Number(data[index].initSellNum).toFixed(0)
                                callback()
                            }
                            callback(new Error('填写有误'))
                        }
                    },

                    {
                        name: 'status',
                        type: 'slot',
                        defaultValue: '1',
                        label: '状态',
                        required: true,
                    },
                ],
                sku: [], // SKU数据，支持 .sync 修饰符
                theme: 2, // SKU选择栏主题风格，可选1或2
                showForm: true, // 是否显示SKU选择栏  false 显示 true 隐藏
                inputValueArr: [],
                inputValueArrTemp: []
            },
            isUpdate: false,
            submitButtonText: '发布商品', // 提交按钮方案
            infoForm: { // 基础信息
                categoryId: [], //	是	int	类目id （数据来源：接口 - /order/comm/commodityCategory/commList）

                name: '', //	是	string	商品名称

                imageList: [], //	是	Object[]	图片列表
                details: '', //	否	string	详情
                status: '', //	是	string	状态（字典分组：enable_status）
                goodsNo: '', // 商品编号
                firstCommissionProportion: '',
                secondCommissionProportion: '',
                thirdCommissionProportion: '',
                shippingTemplateId: ''
            },
            infoRules: { // 基础验证
                name: [
                    { required: true, message: '请输入商品名称', trigger: 'blur' },
                    { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
                ],
                brandId: [
                    { required: true, message: '请选择品牌', trigger: 'change' }
                ],
                goodsType: [
                    { required: true, message: '请选择类型', trigger: 'change' }
                ]
            },
            categoryIdArr: [], // 获取路由 categoryId
            categoryArrStr: '', // 回显 category
            goodsAttrDataList: [], // 类目商品属性库列表
            goodsSaleDataList: [], // 类目的销售属性列表
            goodsSaleDataListValue: [],
            goodsAttrData: [{ formconfig: {}, formData: {} }],
            formFiledData: {}, // 表单组件数 商品属性组列表
            currentStatus: 100, // 当前列表状态
            categoryList: [], // 目类列表
            brandList: [], // 品牌
            dialog: { visible: false, title: '编辑', type: '', row: {}, list: [], batch: false, titleArr: [] },
            selectionId: [], // 选 中 id
            parArray: [], // 按钮权限
            skuList: [],
            lastSkuStatus: [],
            changeGoodsStatusNum: 0,
            tagList: [],//标签
            seletedTag: [],
            dialogVisible: false,
            dialogSkuVisible: false,
            tagForm: {
                name: '',
                tagType: '1',
                tagClass: ''
            },
            labelPageNo: 1,
            labelPageSize: 10,
            labelTotalNum: 0,
            showTagDialog: false,
            tagSelectionList: [],
            bindingSkuNo: '',
            skuIndex: 0,
            editTagList: [],
            detail: {
                calculType: 0
            },
            tableData: [],
            tableDataF: [],
            hadRechargeAmount: 0,//已充值金额
            awaitEarnestMoney: 0,//冻结金额
            activeEarnestMoney: 0,//可用金额
            serverRate: 0,
            userRate: 0,
            firstNormalCommProp: 0,
            awaitEarnestMoney1: 0,//将冻结金额
            isSave: false,
            goods_types: [
                {
                    dictId: '1',
                    dictName: '普通商品'
                },
                {
                    dictId: '3',
                    dictName: '赠品'
                }
            ],
            profit: true,//盈利
            pageNo: 1,
            pageSize: 10,
            totalNum: 0,
            selectGoodsData: [],
            selectGoodsDatas: [],
            categoryIds: [],
            models: [
                // {
                //     id: '0',
                //     name: '无'
                // }
            ],
            tagIds: [],
            tagIds1: [],
            tagIds2: [],
            Tag: [],
            tag: [],
            tagStore: [],
            tagMarketing: [],
            tagIdsShow: [],
            tagIdsShow1: [],
            tagIdsShow2: [],
            Tag1: [],
            tagMarketings: [],
            tagMarketingsT: [],
            selfCommissionFlag: '1',
            goodsList1: []
        }
    },
    mixins: [mixinsGoodsEdit, mixinsGoodsEditQuill, mixinsGiftlist, common],
    // mounted () { this.addQuillTitle() },
    created() {
        this.getModelsList()
        this.getCategoryList()
        // this.getPlatInfo()
        if (this.$route.query.type == 'add') {
            this.searchList.list[0].title = "新增礼包"
            this.getmTagList()
            this.getTagList()
            this.getsTagList()
        } else if (this.$route.query.type == 'edit') {
            this.searchList.list[0].title = "编辑礼包"
            this.initialization() // 初始化 信息
        } else {
            this.searchList.list[0].title = "查看礼包"
            this.initialization() // 初始化 信息
        }

    },
    watch: {
        infoForm: {
            handler(newVal, oldVal) {

                console.log(newVal.skuList)
                this.changeGoodsStatusNum++
            },
            deep: true
        },
        skuFormConfig: {
            handler(newVal, oldVal) {
                this.$nextTick(() => {
                    if (newVal) {
                        newVal.sku.forEach(item => {
                            this.$nextTick(() => {
                                item.stock = '1'
                            })
                        })
                        this.$forceUpdate()
                        this.skuFormConfig = newVal
                    }
                })
            },
            deep: true,
            immediate: true
        },
    },
    computed: {
        newObj() {
            return JSON.parse(JSON.stringify(this.skuFormConfig));
        },
    },
    methods: {
        changePrice(e) {
            this.commissions[0].price = ((e * this.commissions[0].rate) / 100).toFixed(2)
            this.commissions[1].price = ((e * this.commissions[1].rate) / 100).toFixed(2)
            this.commissions[2].price = ((e * this.commissions[2].rate) / 100).toFixed(2)
        },
        changeRate(e, index) {

            this.commissions[index].price = ((this.sku1[0].price * this.commissions[index].rate) / 100).toFixed(2)
        },
        changeR(value) {
            this.selfCommissionFlag = ' '
        },
        getImage1(val, index) {
            this.sku1[0].images = val
        },
        changeImage(val) {
            console.log(val)
            this.fileList = val
        },
        selectT(e, index) {
            // console.log(this.Tag, index, this.tagIds1)
            this.tag = []
            let tempArr = []
            this.tagIds1.forEach(item => {
                let obj = {
                    id: item.value,
                    name: item.label,
                    selected: 0,
                    childTags: []
                }
                tempArr.push(obj)
            })
            console.log(tempArr)
            for (let i = 0; i < tempArr.length; i++) {
                this.tagIds2.forEach(item => {
                    if (this.Tag[i]) {
                        this.Tag[i].forEach(itm => {
                            if (itm == item.id) {
                                let obj1 = {
                                    id: item.id,
                                    name: item.name,
                                    selected: 1,
                                    childTags: []
                                }
                                tempArr[i].childTags.push(obj1)
                            }
                        })
                    }

                })

                let objectD = {
                    id: tempArr[i].id,
                    name: tempArr[i].name,
                    selected: tempArr[i].selected,
                    childTags: tempArr[i].childTags
                }
                this.tag.push(objectD)
            }
            console.log(this.tag)
        },
        selectTs(e, index) {
            // console.log(this.Tag1, index, this.tagIdsShow1)
            this.tagStore = []
            let tempArr = []
            this.tagIdsShow1.forEach(item => {
                let obj = {
                    id: item.value,
                    name: item.label,
                    selected: 0,
                    childTags: []
                }
                tempArr.push(obj)
            })
            console.log(tempArr)
            for (let i = 0; i < tempArr.length; i++) {
                this.tagIdsShow2.forEach(item => {
                    if (this.Tag1[i]) {
                        this.Tag1[i].forEach(itm => {
                            if (itm == item.id) {
                                let obj1 = {
                                    id: item.id,
                                    name: item.name,
                                    selected: 1,
                                    childTags: []
                                }
                                tempArr[i].childTags.push(obj1)
                            }
                        })
                    }

                })

                let objectD = {
                    id: tempArr[i].id,
                    name: tempArr[i].name,
                    selected: tempArr[i].selected,
                    childTags: tempArr[i].childTags
                }
                this.tagStore.push(objectD)
            }
            console.log(this.tagStore)
        },
        changeD(e) {
            console.log(this.tagMarketingsT, e)
            this.tagMarketing = []
            this.tagMarketings.forEach(item => {
                this.tagMarketingsT.forEach(itm => {
                    if (item.id == itm) {
                        let obj = {
                            id: item.id,
                            name: item.name,
                            selected: 1
                        }
                        this.tagMarketing.push(obj)
                    }
                })

            })
        },
        changeTag(e) {
            console.log(this.tagMarketingsT, e)
            this.tagMarketing = []
            if (!e) {
                this.isSelect = true
                this.tagMarketings.forEach(item => {
                    this.tagMarketingsT.forEach(itm => {
                        if (item.id == itm) {
                            let obj = {
                                id: item.id,
                                name: item.name,
                                selected: 1
                            }
                            this.tagMarketing.push(obj)
                        }
                    })

                })
            }
            console.log(this.tagMarketing)
        },
        getmTagList() {
            this.tagMarketingsT = []
            this.tagMarketing = []
            let data = {
                pageNo: 1,
                pageSize: 100000
            }
            this.axios.post('/tagPool/marketing/pageList', data)
                .then(res => {
                    this.tagMarketings = res.data.list;
                    if (this.infoForm.tagMarketing) {
                        this.infoForm.tagMarketing.forEach(item => {
                            if (item.selected == 1) {
                                this.tagMarketingsT.push(item.id)
                            }

                        })
                        this.tagMarketings.forEach(item => {
                            this.tagMarketingsT.forEach(itm => {
                                if (item.id == itm) {
                                    let obj = {
                                        id: item.id,
                                        name: item.name,
                                        selected: 1
                                    }
                                    this.tagMarketing.push(obj)
                                }
                            })

                        })
                    }

                })
            console.log(this.tagMarketings)
        },
        getTagList() {
            this.tagIds = []
            this.axios.post('/tagPool/filter/categoryList', {})
                .then(res => {
                    res.data.forEach(item => {
                        let obj = {
                            value: item.dictId,
                            label: item.dictName,
                            children: []
                        }
                        this.tagIds.push(obj)
                    })
                    this.getSecondTag()
                })
        },
        getSecondTag() {
            let data = {
                pageNo: 1,
                pageSize: 100000,
                status: 1,
                isShow: 1
            }
            this.axios.post('/tagPool/filter/pageList', data)
                .then(res => {
                    this.tagIds2 = res.data.list
                    res.data.list.forEach(item => {
                        item.id = String(item.id)
                        item.label = item.name
                        this.tagIds.forEach(itm => {
                            if (item.pid == itm.value) {
                                let obj = {
                                    value: item.id,
                                    label: item.label,
                                }
                                itm.children.push(obj)
                            }
                        })
                    })

                    this.tagIds1 = this.tagIds

                    console.log(this.tagIds1, res.data.tag)
                    if (this.infoForm.tag) {
                        this.infoForm.tag.forEach(item => {
                            for (let i = 0; i < this.tagIds1.length; i++) {
                                if (item.id == this.tagIds1[i].value) {
                                    this.Tag[i] = []
                                    item.childTags.forEach(itm => {
                                        if (itm.selected == 1) {
                                            this.Tag[i].push(String(itm.id))
                                        }

                                    })
                                    console.log(this.Tag[i])
                                }
                            }
                        })
                    }

                    this.selectT()
                })
        },
        getsTagList() {
            this.tagIdsShow = []
            this.axios.post('/tagPool/show/categoryList', {})
                .then(res => {
                    res.data.forEach(item => {
                        let obj = {
                            value: item.dictId,
                            label: item.dictName,
                            children: []
                        }
                        this.tagIdsShow.push(obj)
                    })
                    this.getSecondsTag()
                })
        },
        getSecondsTag() {
            let data = {
                pageNo: 1,
                pageSize: 100000,
                goodsType: '2',
                categoryFirst: '2'
            }
            this.axios.post('/tagPool/show/pageList', data)
                .then(res => {
                    this.tagIdsShow2 = res.data.list
                    res.data.list.forEach(item => {
                        item.id = String(item.id)
                        item.label = item.name
                        this.tagIdsShow.forEach(itm => {
                            if (item.pid == itm.value) {
                                let obj = {
                                    value: item.id,
                                    label: item.label,
                                }
                                itm.children.push(obj)
                            }
                        })
                    })

                    this.tagIdsShow1 = this.tagIdsShow
                    console.log(this.tagIdsShow1)
                    if (this.infoForm.tagStore) {
                        this.infoForm.tagStore.forEach(item => {
                            for (let i = 0; i < this.tagIdsShow1.length; i++) {
                                if (item.id == this.tagIdsShow1[i].value) {
                                    this.Tag1[i] = []
                                    item.childTags.forEach(itm => {
                                        if (itm.selected == 1) {
                                            this.Tag1[i].push(String(itm.id))
                                        }

                                    })
                                    console.log(this.Tag1[i])
                                }
                            }
                        })
                    }

                    this.selectTs()
                })
        },
        filterMethod(query, item) {
            return item.goodsSkuName.indexOf(query) > -1
        },
        addShopGoods() {
            this.isSelectGoods = true
            if (this.$refs.myTransfer) {
                this.$refs.myTransfer.$children["0"]._data.query = '';
                // 清空右边搜索
                this.$refs.myTransfer.$children["3"]._data.query = '';
            }
            this.getGoods()
        },

        deleteGoods(index) {
            // for(let i=0;i<this.chooseGoods.length;i++){
            //     if(this.chooseGoods[i].goodsSkuId==this.goodsList[index].goodsSkuId){
            //         this.chooseGoods.splice(i,1)
            //     }
            // }
            this.chooseGoods = []
            this.goodsList.splice(index, 1)
            this.goodsList.forEach(item => {
                this.chooseGoods.push(item.goodsSkuId)
            })
        },
        openSelect() {
            this.isSelect = !this.isSelect
            this.$nextTick(() => {
                this.$refs['refTag'].toggleMenu()
            })
        },
        // changeTag(e) {
        //     console.log(this.infoForm.tags, e)
        //     this.sTags = []
        //     if (!e) {
        //         this.isSelect = true
        //         this.tags.forEach(item => {
        //             this.infoForm.tags.forEach(itm => {
        //                 if (item.id == itm) {
        //                     this.sTags.push(item)
        //                 }
        //             })

        //         })
        //     }
        // },
        end() {

        },
        start() {

        },
        deleteG(index) {
            this.selectGoodsDatas.splice(index, 1)
        },
        selectData() {
            this.goodsList = []
            console.log(this.chooseGoods, this.goodsSkuDataList)
            this.goodsSkuDataList.forEach(item => {
                this.chooseGoods.forEach(itm => {
                    if (item.goodsSkuId == itm) {
                        // let obj = {
                        //     id: item.id,
                        //     goodsSkuId: item.goodsSkuId,
                        //     goodsSkuNo: item.goodsSkuNo,
                        //     num: item.num,
                        //     goodsSkuName: item.goodsSkuName
                        // }
                        this.goodsList.push(item)
                    }
                })
            })
            this.goodsList.forEach(item => {
                this.goodsList1.forEach(itm => {
                    if (item.goodsSkuId == itm.goodsSkuId) {
                        item.num = itm.num
                    }
                })
            })
            console.log(this.goodsList)
            this.isSelectGoods = false

            let categoryIds = [];
            this.goodsList = this.setC(this.goodsList)
            categoryIds = this.goodsList.map(item => {
                return item.goodsSkuNo.substring(0, 2)
            })
            this.infoForm.categoryId = Array.from(new Set(categoryIds))
            this.goodsList1 = this.goodsList
        },
        //去重
        setC(arr) {
            let newArr = []
            for (let i = 0; i < arr.length; i++) {
                for (let j = i + 1; j < arr.length; j++) {
                    if (arr[i].goodsSkuId == arr[j].goodsSkuId) {
                        arr.splice(j, 1)
                        j--
                    }
                }
            }
            return arr
        },
        fetchDataG() {
            this.pageNo = 1
            this.getGoods()
        },
        getGoods() {
            // let data = {
            //     pageNo: 1,
            //     pageSize: 100000,
            //     nameOrGoodsNo: ''
            // }
            this.axios.get('/giftPackage/skuDataList?nameOrGoodsNo=' + '').then(res => {
                if (res.code == 0) {
                    this.goodsSkuDataList = res.data
                    // this.totalNum = res.data.totalNum
                }
            })
        },
        // 初始化 信息
        initialization() {
            const queryObj = this.$route.query
            let category
            // 判断是否有 商品 ID 和 TYPE 类型 双从判断 当前页面状态
            // 获取商品信息 - 编辑模式
            this.getCategoryList()
            if (queryObj.type === 'edit' || queryObj.type === 'look') {
                this.getGoodInfo(queryObj.id)
                this.currentPageStatus = 'edit'
                this.submitButtonText = '修改商品'
            }
        },
        getCategoryList() {
            this.axios.post('/giftPackage/getFirstCategory', {})
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.categoryIds = res.data
                    }
                })
        },
        getModelsList() {
            let data = {
                pageNo: 1,
                pageSize: 1000
            }
            this.axios.post('/shippingTemplate/pageList', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        let arr = []
                        let obj = {
                            id: 0,
                            name: '无'
                        }
                        arr.push(obj)
                        this.models = arr.concat(res.data.list)
                        // this.models = this.models.concat(res.data.list)
                    }
                })
        },
        //获取模板详情
        getTransportModel(val) {
            console.log(val)
            if (val == 0) {
                this.tableData = []
                this.tableDataF = []
                this.detail.calculType = ''
                return
            }
            let data = {
                id: val
            }
            this.axios.post('/shippingTemplate/get', data)
                .then(res => {
                    if (res.code == 0) {
                        this.detail = res.data ? res.data : null
                        this.tableData = this.detail ? this.detail.regions : []
                        if (this.tableData) {
                            this.tableData.forEach(item => {
                                Object.assign(item, { address: item.betterAddress })
                                if (item.regionJson) {
                                    Object.assign(item, { addressData: JSON.parse(item.regionJson) })
                                }

                            })
                        }


                        this.tableDataF = this.detail && this.detail.freeList ? this.detail.freeList : []
                        if (this.tableDataF) {
                            this.tableDataF.forEach(item => {
                                Object.assign(item, { address: item.betterAddress })
                                Object.assign(item, { addressData: JSON.parse(item.regionJson) })
                            })
                        }

                        this.arr = []
                        if (this.detail) {
                            this.arr.push(String(this.detail.isFree))
                        }
                        // if (this.$route.query.oType == 0) {
                        //   if (this.detail && this.detail.calculType == 2) {
                        //     this.skuFormConfig.structure.splice(3, 1)
                        //     if (this.infoForm.platformIdOrigin == 0) {
                        //       this.skuFormConfig.structure.splice(13, 1)
                        //       // this.isUpdate = true
                        //     } else {
                        //       this.skuFormConfig.structure.splice(12, 1)
                        //       // this.isUpdate = false
                        //     }
                        //   } else {
                        //     this.skuFormConfig.structure.splice(0, 1)
                        //     this.skuFormConfig.structure.splice(2, 1)
                        //     if (this.infoForm.platformIdOrigin == 0) {
                        //       this.skuFormConfig.structure.splice(12, 1)
                        //       // this.isUpdate = true
                        //     } else {
                        //       this.skuFormConfig.structure.splice(11, 1)
                        //       // this.isUpdate = false
                        //     }
                        //   }

                        // } else {
                        //   console.log(666666, this.detail)
                        //   if (this.detail && this.detail.calculType == 2) {
                        //     console.log(555)
                        //     this.skuFormConfig.structure.splice(13, 1)
                        //   } else {
                        //     this.skuFormConfig.structure.splice(0, 1)
                        //     this.skuFormConfig.structure.splice(12, 1)
                        //   }

                        // }
                        this.$forceUpdate()
                    }
                })

        },
        // 获取 商品信息
        getGoodInfo(goodsId) {
            this.breadcrumbTitle = '编辑商品'
            this.chooseGoods = []

            this.axios.get('/giftPackage/details?id=' + goodsId).then((res) => {
                // const categoryId = res.data.categoryInfo.id

                this.infoForm = Object.assign(this.infoForm, res.data)
                this.getmTagList()
                this.getTagList()
                this.getsTagList()
                if (res.data.shippingTemplateId) {
                    this.getTransportModel(res.data.shippingTemplateId)
                }
                this.goodsList = res.data.goodsList || []
                let categoryIds = [];
                categoryIds = this.goodsList.map(item => {
                    return item.goodsSkuNo.substring(0, 2)
                })
                this.goodsList.forEach(item => {
                    this.chooseGoods.push(item.goodsSkuId)
                })
                this.goodsList1 = this.goodsList
                this.infoForm.categoryId = Array.from(new Set(categoryIds))
                this.infoForm.images.forEach(item => {
                    let obj = {
                        mainFlag: true,
                        url: item
                    }
                    this.fileList.push(obj)
                })
                // this.fileList = res.data.images
                this.startTime.push(res.data.validityStartTime)
                this.startTime.push(res.data.validityEndTime)
                this.sku1[0].images = res.data.detailImage[0]
                this.sku1[0].marketPrice = res.data.marketPrice
                this.sku1[0].price = res.data.price
                this.sku1[0].points = res.data.points
                this.sku1[0].stock = res.data.stock
                this.sku1[0].fakeSaleNum = res.data.fakeSaleNum
                this.sku1[0].saleNum = res.data.saleNum
                this.sku1[0].status = String(res.data.status)
                this.commissions[0].rate = res.data.firstCommissionProportion
                this.commissions[1].rate = res.data.secondCommissionProportion
                this.commissions[2].rate = res.data.thirdCommissionProportion
                this.commissions[0].price = ((this.sku1[0].price * res.data.firstCommissionProportion) / 100).toFixed(2)
                this.commissions[1].price = ((this.sku1[0].price * res.data.secondCommissionProportion) / 100).toFixed(2)
                this.commissions[2].price = ((this.sku1[0].price * res.data.thirdCommissionProportion) / 100).toFixed(2)
                if (res.data.selfCommissionFlag == 1) {
                    this.checkList.push('1')
                } else {
                    this.checkList = []
                }
            }).catch((err) => {
                console.log(err)
            })
        },

        // 表单规则验证
        async verificationData() {
            const infoForm = this.infoForm
            console.log(infoForm)
            if (this.fileList.length == 0) {
                this.$message.warning('请上传商品图片')
                return
            }
            if (this.infoForm.details == '') {
                this.$message.warning('请填写商品详情')
                return
            }

            this.$refs['infoForm'].validate((valid) => {
                if (valid) {

                    this.submitDate()
                } else {
                    this.$message.warning('请完善信息再提交！')
                    console.log('error submit!!')
                    return false
                }
            })
        },
        back() {
            this.$router.go(-1)
        },
        // 提交 数据
        async submitDate() {
            const params = Object.assign({}, this.infoForm)


            params.id = this.$route.query.id
            params.goodsList = this.goodsList
            params.tag = this.tag
            params.tagStore = this.tagStore
            params.tagMarketing = this.tagMarketing
            let detailImage = []
            this.fileList.forEach(item => {
                detailImage.push(item.url)
            })
            let images = []
            images.push(this.sku1[0].images)
            params.detailImage = images

            params.images = detailImage
            params.stock = this.sku1[0].stock
            params.price = this.sku1[0].price
            params.marketPrice = this.sku1[0].marketPrice
            params.points = this.sku1[0].points
            params.fakeSaleNum = this.sku1[0].fakeSaleNum
            params.saleNum = this.sku1[0].saleNum
            params.firstCommissionProportion = this.commissions[0].rate
            params.secondCommissionProportion = this.commissions[1].rate
            params.thirdCommissionProportion = this.commissions[2].rate
            params.status = this.sku1[0].status
            // console.log(this.checkList)
            if (this.checkList.length != 0) {
                params.selfCommissionFlag = 1
            } else {
                params.selfCommissionFlag = 0
            }

            if (this.startTime) {
                params.validityStartTime = this.startTime[0]
                params.validityEndTime = this.startTime[1]
            } else {
                params.validityStartTime = ''
                params.validityEndTime = ''
            }
            if (this.time == 0) {
                this.time = 3; //设定间隔时间（秒）
                //启动计时器，倒计时time秒后自动关闭计时器。
                var index = setInterval(function () {
                    this.time--;
                    if (this.time == 0) {
                        clearInterval(index);
                    }
                }, 1000);
                this.axios.post('/giftPackage/addOrUpdate', params).then((res) => {
                    if (res.code === 0) {
                        // this.$message({ type: 'success', message: '添加商品成功!' })
                        this.$notify({
                            title: '成功',
                            message: '修改成功!',
                            type: 'success',
                            duration: 3000
                        })
                        this.isInfo = false
                        this.toOtherPages('giftManagement')
                    } else {
                        this.time = 0
                    }
                }).catch((err) => {
                    console.log(err)
                    this.initialization() // 初始化 信息
                })
            }
            // else {
            //     this.$message.warning('已提交，无需再次提交')
            //     console.log('已提交，无需再次提交');
            // }

        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/styles/modifyState.scss";

.transfer-gift-form {
    margin-left: 10%;

    .el-transfer-panel {
        width: calc((100% - 60px - 40px) / 2);
        float: left;

        &:first-child {
            .el-transfer-panel__item {
                .el-input-number {
                    display: none
                }
            }
        }

        .el-transfer-panel__item {
            .transfer-label {
                width: 140px;
                display: inline-block;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 1;
                /* 可以显示的行数，超出部分用...表示*/
                -webkit-box-orient: vertical;
            }

            .el-input-number {
                width: 100px;
                float: right;

                // .el-input {}
            }
        }

    }

    .el-transfer__buttons {
        float: left;
        display: flex;
        flex-wrap: wrap;
        width: 60px;
        padding: 0 20px;
        margin-top: 100px;

        .el-button {
            margin-bottom: 10px;
        }

        .el-button+.el-button {
            margin-left: 0;
        }
    }
}

::v-deep .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {
    font-size: 16px;
    color: #303133;
    font-weight: 400;
    margin-right: 100px !important;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #2d46ee !important;
}


::v-deep .el-transfer-panel__item.el-checkbox :hover {
    color: #2d46ee !important;
}

::v-deep .el-transfer-panel {
    width: 300px;
}

::v-deep .transfer-gift-form .el-transfer-panel .el-transfer-panel__item .transfer-label {
    width: 99%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

::v-deep .el-transfer__buttons .el-button--primary.is-disabled,
.el-button--primary.is-disabled:active,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:hover {
    color: #FFF;
    background-color: #2d46ee !important;
    border-color: #2d46ee !important;
}

.el-select {
    border-left: none !important;
    border-right: none !important;
}

.dItem {
    height: 22px;
    line-height: 22px;
    background-color: #f4f4f5;
    border: 1px solid #e9e9eb;
    color: #909399;
    font-size: 12px;
    border-radius: 4px;
}

.el-tag--dark {
    background-color: #2D46EE;
    border-color: #2D46EE;
    color: #fff;
}

.el-select[data-v-68607b2e] {
    border-left: none !important;
    border-right: none !important;
    border-radius: 5px;
}

.search-box {
    width: 100%;
    height: 50px;
    background: #f8f8f8;
    padding: 0 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    border: 1px solid #e8eaec;
    border-bottom: 0;
}

::v-deep .rate .el-input__suffix {
    margin-top: 6px;
}

.line {
    width: 100%;
    height: 0px;
    border: 1px solid #c0c0cc;
    opacity: 0.5;
    margin-top: 6px;
}

.info-item {
    margin-bottom: 24px;
}

.info-bottom {
    width: 426px;
    min-height: 58px;
    background: #e9ecfe;
    opacity: 1;
    border-radius: 0px;

    .info-bottom-item {
        text-align: left;
        padding: 8px 14px;
    }
}

::v-deep.el-dialog__wrapper {
    // text-align: center;
    // white-space: nowrap;
    // overflow: auto;

    // &:after {
    //     content: "";
    //     display: inline-block;
    //     vertical-align: middle;
    //     height: 100%;
    // }

    // .el-dialog {
    //     margin: 30px auto !important;
    //     display: inline-block;
    //     vertical-align: middle;
    //     white-space: normal;
    // }

    .el-dialog__header {
        text-align: left;
        border-bottom: none;
    }

    .info {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 0px;
        color: #303033;
        opacity: 1;
        text-align: left;
    }

    .info-b {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #909099;
        opacity: 1;
        margin-top: 12px;
        text-align: left;
    }

    .info-q {
        width: 124px;
        height: 40px;
        line-height: 40px;
        background: #ffffff;
        border: 1px solid #909099;
        opacity: 1;
        border-radius: 3px;
        text-align: center;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #909099;
        margin-right: 18px;
        cursor: pointer;
    }

    .info-s {
        width: 126px;
        height: 40px;
        line-height: 40px;
        background: #2d46ee;
        opacity: 1;
        border-radius: 3px;
        text-align: center;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
    }

    .info-s1 {
        width: 126px;
        height: 40px;
        line-height: 40px;
        background: #e3e3e3;
        opacity: 1;
        border-radius: 3px;
        text-align: center;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
    }
}

// .content{color: #333333!important;}
//删除全页面按钮边框
.el-button {
    border: none;
}

.image-text-form {
    .el-form {
        .el-form-item {
            &:first-child {
                .el-form-item__label {
                    &:before {
                        color: #ff0000;
                        content: "*";
                    }
                }
            }
        }
    }
}

.goods-category-edit {
    .edit-btn {
        background-color: #e3edff;
        color: #4168e7;
        font-size: 14px;
        text-align: center;
        width: 44px;
        height: 24px;
        line-height: 24px;
        border-radius: 12px;
        padding: 3px 8px;
        margin-left: 10px;
        cursor: pointer;
    }
}

.status-box {
    font-size: 16px;
    height: 40px;
    line-height: 40px;

    .list,
    .right {
        float: left;
    }

    .list {
        width: 100px;
        text-align: center;
    }

    .right {
        padding-top: 15px;
        width: calc(100% - 100px);

        .el-radio__label {
            font-size: 16px;
        }
    }
}

.bottom-but {
    margin-top: -20px;
    text-align: left;

    .el-button {
        width: 184px;
        height: 48px;
        border-radius: 4px;
        font-size: 18px;
    }

    .el-button+.el-button {
        margin-left: 32px;
    }
}

.el-select {
    border-left: 1px solid #d8dce5;
    border-right: 1px solid #d8dce5;
    border-radius: 5px;

    input[type="text"],
    input[type="number"] {
        border-radius: 0;
        border-left: none;
        border-right: none;
    }
}

.attr {
    margin-top: 0;
}

.content {
    padding-bottom: 10px !important;
}

//v1.4.0新增
.labelbox {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;

    .labelitem {
        background-color: #f0f3fd;
        padding: 2px 20px;
        font-size: 14px;
        color: #4168e7;
        position: relative;
        margin-right: 20px;
        line-height: 28px;

        .labelicon {
            color: #4168e7;
            cursor: pointer;
            position: absolute;
            font-size: 16px;
            right: -6px;
            top: -6px;
        }
    }
}

.loglabelbox {
    padding: 20px 0;
    box-sizing: border-box;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;

    .loglabeltopbox {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        border-bottom: 1px dashed #cccccc;

        .labelitem {
            background-color: #f0f3fd;
            padding: 2px 20px;
            font-size: 14px;
            color: #4168e7;
            position: relative;
            margin-right: 20px;
            margin-bottom: 14px;
            cursor: pointer;
        }

        .labelitemc {
            .labelicon {
                color: #4168e7;
                cursor: pointer;
                position: absolute;
                font-size: 16px;
                right: -6px;
                top: -6px;
            }
        }

        .notselected {
            background-color: #4168e7;
            color: #ffffff;
        }

        .selected {
            background-color: #f3f3f3;
            color: #333333;
        }
    }

    .circlebox {
        font-size: 16px;
        color: #4168e7;
        display: flex;
        margin-top: 14px;
        align-items: center;
        margin-bottom: 14px;

        .circle {
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            border-radius: 50%;
            background-color: #4168e7;
            color: white;
            font-size: 12px;
            margin-left: 10px;
            box-sizing: border-box;
        }
    }
}

.circle1 {
    width: 10px;
    height: 10px;
    text-align: center;
    line-height: 20px;
    border-radius: 50%;
    background-color: #4168e7;
    color: white;
    font-size: 12px;
    margin-left: 10px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 4px;
}

.primary-button {
    width: 120px;
    height: 36px;
    background: #4168e7;
    border-radius: 4px;
    line-height: 36px;
    text-align: center;
    color: white;
    font-size: 16px;
    cursor: pointer;
    display: inline-block;
}

.primary-mini {
    width: 68px;
    height: 32px;
    background: #e3edff;
    border-radius: 4px;
    line-height: 32rpx;
    text-align: center;
    font-size: 16px;
    color: #4168e7;
    cursor: pointer;
    display: inline-block;
    margin-right: 20px;
}

.primary-plain {
    width: 120px;
    height: 36px;
    background: #ffffff;
    border: 1px solid #4168e7;
    border-radius: 4px;
    line-height: 36px;
    color: #4168e7;
    text-align: center;
    margin-right: 16px;
    cursor: pointer;
    display: inline-block;
}

.primary-gray {
    width: 120px;
    height: 36px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    margin-right: 16px;
    cursor: pointer;
    display: inline-block;
    line-height: 36px;
    text-align: center;
    color: #999999;
}

#goods-edit #sku-content .sku-box .sku-content-box {
    width: calc(100% - 20px);
}
</style>
  